/** Canonical enterprise department catalog (keep in sync with accounts/department_choices.py). */

export const STANDARD_DEPARTMENTS = [
  'Engineering & Tech',
  'Product & UI/UX',
  'Data Science & Analytics',
  'IT & Infrastructure / DevOps',
  'Cybersecurity',
  'Sales & Business Development',
  'Marketing & Brand',
  'Customer Success',
  'Customer Support',
  'Human Resources & People Ops',
  'Talent Acquisition',
  'Finance & Accounting',
  'Operations & Supply Chain',
  'Procurement',
  'Legal, Risk & Compliance',
  'Administration & Facilities',
  "Strategy / Founder's Office",
];

export const OTHER_DEPARTMENT_VALUE = '__other__';
export const OTHER_DEPARTMENT_LABEL = 'Other / Custom Department';

/**
 * Merge API/company departments with the standard catalog (unique, standards first).
 */
export function mergeDepartmentOptions(companyDepartments = []) {
  const fromCompany = (companyDepartments || [])
    .map((d) => (typeof d === 'string' ? d : d?.name))
    .filter(Boolean);
  const seen = new Set();
  const out = [];
  for (const name of [...STANDARD_DEPARTMENTS, ...fromCompany]) {
    if (!seen.has(name)) {
      seen.add(name);
      out.push(name);
    }
  }
  return out;
}
